import React, { Dispatch, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export default function NoMatch(props: { setTitle: Dispatch<React.SetStateAction<string>>}) {
    const {t} = useTranslation()

    return (
        <div
            style={{
                marginTop: '100px',
                display: 'inline-block',
                justifyContent: 'center',
                alignItems: 'center',
                // height: '100vh',
            }}
        >
            <h1>{t("404.header")}</h1>
            <p>{t("404.content")}</p>
            <p><a href="/">{t("404.click")}</a>{t("404.return_home")}</p>
        </div>
    )
}